const fr = {
  // Navigation
  nav_home: 'Accueil',
  nav_about: 'À Propos',
  nav_services: 'Services',
  nav_fleet: 'Flotte',
  nav_schedules: 'Horaires',
  nav_amenities: 'Équipements',
  nav_contact: 'Contact',
  nav_bookNow: 'Réserver',

  // Common
  common_backHome: 'Retour à l\'accueil',

  // Hero
  hero_tagline: 'Voyage Interurbain Premium · Panama',
  hero_h1_line1: 'Vivez',
  hero_h1_line2: 'le Voyage de Luxe',
  hero_h1_line3: 'à travers le Panama',
  hero_subtitle: 'Phoenix Transportation redéfinit le voyage interurbain entre la Ville de Panama et Chitré — en combinant confort première classe, service professionnel et fiabilité absolue.',
  hero_cta1: 'Réservez votre Voyage',
  hero_cta2: 'Découvrir Notre Flotte',
  hero_card_dailyDeparture: 'Départ Quotidien',
  hero_card_perSeat: 'À partir de par Place',
  hero_card_journeyTime: 'Durée du Trajet',
  hero_scroll: 'Défiler',

  // About
  about_eyebrow: 'À Propos de Phoenix Transportation',
  about_h2_line1: 'Redéfinissant',
  about_h2_line2: 'le Transport',
  about_h2_line3: 'au Panama',
  about_p1: 'Phoenix Transportation est un service de bus de luxe dédié à fournir un transport interurbain sûr, confortable et fiable entre la <strong>Ville de Panama et Chitré</strong>.',
  about_p2: 'Conçue pour répondre à la demande croissante d\'options de voyage premium, l\'entreprise combine des normes de flotte haut de gamme avec l\'efficacité opérationnelle — apportant un nouveau niveau de sophistication aux routes interurbaines du Panama.',
  about_p3: 'Nous croyons que chaque voyage doit être un plaisir. Notre équipe de professionnels formés s\'engage à rendre votre expérience de voyage parfaite du début à la fin.',
  about_motto: 'Luxe. Sécurité. Fiabilité.',
  about_stat_buses: 'Bus de Luxe',
  about_stat_seats: 'Sièges Premium',
  about_stat_service: 'Service Quotidien',
  about_stat_route: 'Ville à Ville',

  // Services
  services_eyebrow: 'Nos Services',
  services_h2_line1: 'Solutions de',
  services_h2_line2: 'Voyage Complètes',
  services_subtitle: 'Chaque aspect de votre voyage est soigneusement élaboré pour offrir le plus haut standard de transport interurbain au Panama.',
  services_0_title: 'Routes Express Interurbaines',
  services_0_desc: 'Service direct et sans escale entre la Ville de Panama et Chitré avec un départ quotidien. Notre route express est conçue pour les voyageurs qui valorisent la ponctualité et le confort avant tout.',
  services_1_title: 'Sièges et Confort Premium',
  services_1_desc: 'Chaque siège est un siège premium. Profitez de fauteuils en cuir inclinables spacieux, d\'un espace généreux pour les jambes et d\'un contrôle climatique individuel — tout conçu pour le voyageur exigeant.',
  services_2_title: 'Sécurité et Fiabilité',
  services_2_desc: 'Nos chauffeurs certifiés suivent des protocoles de sécurité stricts sur chaque route. Nos bus sont régulièrement entretenus et inspectés pour garantir que vous voyagez toujours en toute tranquillité.',
  services_3_title: 'Service de Conciergerie Professionnel',
  services_3_desc: 'Notre personnel à bord assure une expérience de voyage sans faille. De l\'assistance à l\'embarquement au soutien en cours de route, nous offrons un service de niveau hôtelier à chaque kilomètre.',
  services_4_title: 'Connectivité à Bord',
  services_4_desc: 'Restez connecté tout au long de votre voyage avec le Wi-Fi haut débit gratuit. Que ce soit pour le travail ou les loisirs, nous vous gardons en ligne et productif à chaque trajet.',
  services_5_title: 'Assistance Bagages',
  services_5_desc: 'Gestion gratuite des bagages pour tous les passagers. Notre équipe vous aide au chargement et au déchargement, afin que vous puissiez vous concentrer sur le voyage sans aucun tracas.',

  // Fleet Home Section
  fleet_eyebrow: 'Notre Flotte',
  fleet_h2_line1: 'Bus de Luxe Conçus',
  fleet_h2_line2: 'pour votre Confort',
  fleet_subtitle: 'Notre flotte de 2 coaches de luxe dernier cri est méticuleusement entretenue pour offrir la meilleure expérience de voyage sur chaque route.',
  fleet_specs_title: 'Spécifications de la Flotte',
  fleet_spec_0: '57 Sièges Premium',
  fleet_spec_1: 'Climatisation Complète',
  fleet_spec_2: 'Wi-Fi à Bord',
  fleet_spec_3: 'Espace Généreux pour les Jambes',
  fleet_spec_4: 'Chauffeurs Professionnels',
  fleet_spec_5: 'Certifié Sécurité',
  fleet_spec_6: 'Compartiment à Bagages',
  fleet_spec_7: 'Ports de Charge USB',
  fleet_bookSeat: 'Réserver une Place',
  fleet_route_departure_label: 'Départ',
  fleet_route_arrival_label: 'Arrivée',
  fleet_route_duration_label: 'Durée',
  fleet_route_trips_label: 'Trajets Quotidiens',
  fleet_route_class_label: 'Classe',
  fleet_route_duration_val: '~3,5 Heures',
  fleet_route_trips_val: '1 Départ',
  fleet_route_class_val: 'Luxe',

  // Contact
  contact_eyebrow: 'Contactez-nous',
  contact_h2_line1: 'Commencez',
  contact_h2_line2: 'votre Voyage',
  contact_phone_label: 'Téléphone',
  contact_email_label: 'E-mail',
  contact_route_label: 'Itinéraire',
  contact_hours_label: 'Heures de Service',
  contact_hours_val: 'Départ Quotidien: 4:00 AM',
  contact_form_fullName: 'Nom Complet',
  contact_form_fullName_ph: 'Votre nom complet',
  contact_form_email: 'E-mail',
  contact_form_email_ph: 'votre@email.com',
  contact_form_phone: 'Numéro de Téléphone',
  contact_form_phone_ph: '+507 0000-0000',
  contact_form_travelDate: 'Date de Voyage',
  contact_form_route: 'Itinéraire',
  contact_form_route_ph: 'Sélectionnez votre itinéraire',
  contact_form_route_opt1: 'Ville de Panama → Chitré',
  contact_form_route_opt2: 'Chitré → Ville de Panama',
  contact_form_route_opt3: 'Aller-Retour',
  contact_form_message: 'Message',
  contact_form_message_ph: 'Demandes spéciales ou questions...',
  contact_form_submit: 'Envoyer la Demande',
  contact_form_sending: 'Envoi en cours...',
  contact_form_note: 'Nous répondons dans les 24 heures',
  contact_form_required: 'requis',
  contact_success_title: 'Message Reçu!',
  contact_success_desc: 'Merci d\'avoir contacté Phoenix Transportation. Nous vous répondrons dans les 24 heures.',

  // Footer
  footer_tagline: 'Service de bus interurbain de luxe reliant la Ville de Panama et Chitré avec confort, sécurité et style.',
  footer_motto: 'Luxe. Sécurité. Fiabilité.',
  footer_quickLinks: 'Liens Rapides',
  footer_routes: 'Itinéraires',
  footer_contact: 'Contact',
  footer_route1: 'Ville de Panama → Chitré',
  footer_route2: 'Chitré → Ville de Panama',
  footer_departure_label: 'Départ Quotidien',
  footer_departure_val: '4:00 AM Chaque Jour',
  footer_journey_label: 'Durée du Trajet',
  footer_journey_val: '~3,5 Heures',
  footer_privacy: 'Politique de Confidentialité',
  footer_terms: 'Conditions d\'Utilisation',

  // Schedules Page
  sched_backHome: 'Retour à l\'accueil',
  sched_title: 'Itinéraires et Horaires',
  sched_subtitle: 'Réservez votre place sur notre départ de luxe quotidien — départ à 4:00 AM depuis la Ville de Panama et Chitré',
  sched_stat_distance_label: 'Distance',
  sched_stat_duration_label: 'Durée',
  sched_stat_departures_label: 'Départs Quotidiens',
  sched_stat_price_label: 'À partir de',
  sched_stat_price_val: '9$ par Place',
  sched_stat_departures_val: '1 par Direction',
  sched_oneWay: 'Aller Simple',
  sched_roundTrip: 'Aller-Retour',
  sched_roundTrip_note: 'Sélectionnez un départ de chaque colonne — nous afficherons le total avant votre réservation.',
  sched_col1_title: 'Ville de Panama → Chitré',
  sched_col1_sub_ow: 'Au départ de la Ville de Panama',
  sched_col1_sub_rt: 'Sélectionnez votre départ aller',
  sched_col2_title: 'Chitré → Ville de Panama',
  sched_col2_sub_ow: 'Au départ de Chitré',
  sched_col2_sub_rt: 'Sélectionnez votre départ retour',
  sched_selected_badge: 'Sélectionné',
  sched_price_label: 'Prix',
  sched_bookNow: 'Réserver',
  sched_select: 'Sélectionner',
  sched_selected_btn: 'Sélectionné',
  sched_summary_outbound: 'Aller',
  sched_summary_return: 'Retour',
  sched_summary_total: 'Total',
  sched_not_selected: 'Non sélectionné',
  sched_outbound_detail: 'Ville de Panama → Chitré',
  sched_return_detail: 'Chitré → Ville de Panama',
  sched_bookRoundTrip: 'Réserver Aller-Retour',
  sched_selectBothLegs: 'Sélectionnez les Deux Trajets pour Continuer',
  sched_terminals_eyebrow: 'Points d\'Embarquement',
  sched_terminals_title: 'Emplacements des Terminaux',
  sched_terminals_subtitle: 'Retrouvez-nous dans ces terminaux. Arrivez au moins 20 minutes avant votre heure de départ prévue.',
  sched_terminal_address: 'Adresse',
  sched_terminal_phone: 'Téléphone',
  sched_terminal_hours: 'Heures du Terminal',
  sched_info_title: 'Informations Importantes',
  sched_info_checkin_title: 'Heure d\'Enregistrement',
  sched_info_checkin_desc: 'Veuillez arriver au terminal au moins 20 minutes avant l\'heure de départ',
  sched_info_baggage_title: 'Politique de Bagages',
  sched_info_baggage_desc: '2 bagages à main (max 10kg chacun) et 2 bagages enregistrés (max 23kg chacun) inclus',
  sched_info_cancel_title: 'Politique d\'Annulation',
  sched_info_cancel_desc: 'Annulation gratuite jusqu\'à 24 heures avant le départ. Remboursement de 50% dans les 24 heures',
  sched_info_ticket_title: 'Validation du Billet',
  sched_info_ticket_desc: 'Pièce d\'identité officielle valide requise. Billets numériques ou imprimés acceptés',

  // Amenities Page
  amen_eyebrow: 'Expérience à Bord',
  amen_title1: 'Équipements',
  amen_title2: 'Premium',
  amen_subtitle: 'Chaque détail à bord est soigneusement élaboré pour que votre voyage soit aussi agréable que la destination.',
  amen_stat1_val: '7',
  amen_stat1_label: 'Équipements Premium',
  amen_stat2_val: '100%',
  amen_stat2_label: 'Confort Garanti',
  amen_stat3_val: '248 km',
  amen_stat3_label: 'Route de Luxe',
  amen_wifi_title: 'Wi-Fi Haut Débit',
  amen_wifi_desc: 'Restez connecté tout au long de votre voyage avec le Wi-Fi haut débit gratuit, vous gardant productif et diverti.',
  amen_wifi_detail: 'Notre Wi-Fi à bord est alimenté par une connexion satellite dédiée, garantissant des vitesses stables même sur la route.',
  amen_ac_title: 'Climatisation Complète',
  amen_ac_desc: 'Les zones climatiques individuelles garantissent que chaque passager profite de la température parfaite, quelle que soit la chaleur tropicale du Panama à l\'extérieur.',
  amen_ac_detail: 'Chaque section du bus maintient sa propre zone climatique avec un contrôle précis de la température. Fini les disputes sur le thermostat — tout le monde voyage dans le confort.',
  amen_seats_title: 'Sièges en Cuir Spacieux',
  amen_seats_desc: 'Des sièges en cuir premium larges conçus pour un confort maximum — donnant à chaque passager l\'espace qu\'il mérite.',
  amen_seats_detail: 'Nos sièges sont fabriqués en cuir pleine fleur avec un soutien lombaire ergonomique. Avec des sièges extra-larges et un espace généreux pour les jambes, chaque voyage se sent comme la première classe.',
  amen_recline_title: 'Sièges Entièrement Inclinables',
  amen_recline_desc: 'Ajustez votre siège à l\'angle parfait et installez-vous pour le trajet. Nos sièges entièrement inclinables vous permettent de voyager dans un confort total.',
  amen_recline_detail: 'Chaque siège s\'incline doucement à l\'angle souhaité d\'une simple pression sur un bouton. Votre siège s\'adapte à vous.',
  amen_screen_title: 'Écrans de Divertissement',
  amen_screen_desc: 'Profitez du divertissement à bord avec des écrans individuels proposant films, musique et contenu sélectionné pour faire passer les kilomètres rapidement.',
  amen_screen_detail: 'Chaque siège est équipé d\'un écran tactile HD personnel chargé d\'une bibliothèque de films, séries, musiques et podcasts.',
  amen_usb_title: 'Ports de Charge USB',
  amen_usb_desc: 'Chaque siège dispose de ports de charge USB individuels pour que vos appareils restent complètement chargés tout au long du trajet.',
  amen_usb_detail: 'N\'arrivez plus avec une batterie déchargée. Chaque siège comprend un port USB-A et USB-C avec charge rapide.',
  amen_luggage_title: 'Stockage Sécurisé des Bagages',
  amen_luggage_desc: 'Les grands compartiments à bagages et le rangement en hauteur gardent vos affaires en sécurité et facilement accessibles tout au long du voyage.',
  amen_luggage_detail: 'De généreux compartiments sous le bus et des rangements en hauteur offrent suffisamment d\'espace pour tous vos bagages.',
  amen_learnMore: 'En savoir plus',
  amen_showLess: 'Voir moins',
  amen_gallery_eyebrow: 'Entrez et Découvrez',
  amen_gallery_title1: 'Visite',
  amen_gallery_title2: 'Intérieure',
  amen_gallery_subtitle: 'Faites un tour visuel de chaque coin de la cabine — du moment où vous montez à bord jusqu\'au siège dans lequel vous vous installez.',
  amen_gal1_label: 'Cabine Principale',
  amen_gal1_caption: 'Des rangées de sièges en cuir premium spacieux s\'étendent sur toute la longueur de la cabine.',
  amen_gal2_label: 'Sièges Premium',
  amen_gal2_caption: 'Cuir pleine fleur avec soutien lombaire et commandes d\'inclinaison individuelles à portée de main.',
  amen_gal3_label: 'Divertissement',
  amen_gal3_caption: 'Écrans tactiles HD personnels à chaque siège avec films, musique et contenu sélectionné.',
  amen_gal4_label: 'Charge et Connectivité',
  amen_gal4_caption: 'Ports de charge USB-A et USB-C intégrés dans chaque accoudoir pour ne jamais manquer de batterie.',
  amen_gal5_label: 'Contrôle Climatique',
  amen_gal5_caption: 'Des bouches d\'air individuelles en hauteur permettent à chaque passager de régler sa température parfaite.',
  amen_gal6_label: 'Stockage des Bagages',
  amen_gal6_caption: 'De généreux compartiments sous le plancher gardent vos bagages en sécurité tout au long du voyage.',
  amen_zoom_hint: 'Cliquez pour agrandir',
  amen_cta_eyebrow: 'Prêt à Voyager?',
  amen_cta_title: 'Vivez Chaque Équipement lors de votre Prochain Voyage',
  amen_cta_subtitle: 'Réservez votre place aujourd\'hui et découvrez pourquoi Phoenix Transportation est le premier service de luxe interurbain du Panama.',
  amen_cta_btn1: 'Voir les Horaires et Réserver',
  amen_cta_btn2: 'Nous Contacter',

  // Fleet Page
  fleet_page_eyebrow: 'Notre Flotte',
  fleet_page_h1_line1: 'Découvrez les Coaches qui',
  fleet_page_h1_line2: 'Définissent le Voyage',
  fleet_page_subtitle: 'Deux coaches de luxe dernier cri — conçus pour la performance, pensés pour le confort et entretenus à la perfection sur chaque route entre la Ville de Panama et Chitré.',
  fleet_page_stat1_label: 'Coaches de Luxe',
  fleet_page_stat2_label: 'Places Totales',
  fleet_page_stat3_label: 'Jours par An',
  fleet_page_stat4_label: 'Route de Luxe',
  fleet_page_badge_flagship: 'Fleuron',
  fleet_page_badge_newest: 'Le plus récent',
  fleet_page_seats_label: 'Places',
  fleet_page_tab_exterior: 'extérieur',
  fleet_page_tab_interior: 'intérieur',
  fleet_page_tab_seat: 'Sièges',
  fleet_page_specs_title: 'Spécifications',
  fleet_page_features_title: 'Équipements à Bord',
  fleet_page_seatmap_title: 'Plan des Places',
  fleet_page_seatmap_note: 'Survolez une place pour la mettre en évidence · Toutes les places sont de classe premium',
  fleet_page_spec_capacity: 'Capacité',
  fleet_page_spec_year: 'Année',
  fleet_page_spec_length: 'Longueur',
  fleet_page_spec_engine: 'Moteur',
  fleet_page_spec_climate: 'Climatisation',
  fleet_page_spec_wifi: 'Connectivité',
  fleet_page_spec_entertainment: 'Divertissement',
  fleet_page_spec_charging: 'Chargement',
  fleet_page_spec_val_capacity: '57 Places',
  fleet_page_spec_val_engine: 'Diesel Euro VI',
  fleet_page_spec_val_climate: 'Climatisation Double Zone',
  fleet_page_spec_val_wifi: 'Wi-Fi Satellite',
  fleet_page_spec_val_entertainment: 'Écrans HD Individuels',
  fleet_page_spec_val_charging: 'USB-A + USB-C par Place',
  fleet_page_highlight_0: 'Sièges en cuir premium entièrement inclinables',
  fleet_page_highlight_1: 'Écrans tactiles HD individuels de divertissement',
  fleet_page_highlight_2: 'Wi-Fi à bord via technologie satellite',
  fleet_page_highlight_3: 'Climatisation de précision à double zone',
  fleet_page_highlight_4: 'Charge rapide USB-A et USB-C à chaque siège',
  fleet_page_highlight_5: 'Grands compartiments à bagages sous le plancher',
  fleet_page_highlight_6: 'Toilettes à bord',
  fleet_page_highlight_7: 'Accompagnateur bilingue professionnel à chaque voyage',
  fleet_page_bus1_name: 'Phoenix I',
  fleet_page_bus1_tagline: 'L\'Expérience Phare',
  fleet_page_bus2_name: 'Phoenix II',
  fleet_page_bus2_tagline: 'Tout Aussi Luxueux, Toujours Prêt',
  fleet_page_safety_eyebrow: 'Votre Sécurité, Notre Priorité',
  fleet_page_safety_title1: 'Construits sur une',
  fleet_page_safety_title2: 'Base de Sécurité',
  fleet_page_safety_0_title: 'Certifié Sécurité',
  fleet_page_safety_0_desc: 'Chaque véhicule dispose de la certification complète de l\'autorité de transport panaméenne et est inspecté mensuellement.',
  fleet_page_safety_1_title: 'Chauffeurs Professionnels',
  fleet_page_safety_1_desc: 'Tous les chauffeurs ont au minimum 10 ans d\'expérience sur les longues distances et passent des contrôles de bien-être réguliers.',
  fleet_page_safety_2_title: 'Surveillance Caméra',
  fleet_page_safety_2_desc: 'Les caméras intérieures et extérieures fonctionnent tout au long de chaque trajet pour la sécurité des passagers.',
  fleet_page_safety_3_title: 'Premiers Secours',
  fleet_page_safety_3_desc: 'Trousses de premiers secours certifiées et personnel formé présents à chaque voyage.',
  fleet_page_safety_4_title: 'Suivi GPS',
  fleet_page_safety_4_desc: 'Suivi GPS en temps réel sur chaque coach, visible par le dispatching 24h/24 7j/7.',
  fleet_page_safety_5_title: 'Suppression d\'Incendie',
  fleet_page_safety_5_desc: 'Systèmes automatiques de suppression d\'incendie installés sur les deux coaches.',
  fleet_page_cta_eyebrow: 'Prêt à Monter?',
  fleet_page_cta_title: 'Réservez votre Place sur Phoenix I ou Phoenix II',
  fleet_page_cta_subtitle: 'Un départ quotidien depuis la Ville de Panama et Chitré à 4:00 AM. Les places sont limitées — assurez la vôtre aujourd\'hui.',
  fleet_page_cta_btn1: 'Voir les Horaires et Réserver',
  fleet_page_cta_btn2: 'Explorer les Équipements',
  fleet_page_seatmap_front: 'Avant',
  fleet_page_seatmap_rear: 'Arrière',
  fleet_page_seatmap_door: 'Porte',
  fleet_page_seatmap_all_premium: 'Toutes les places sont de classe premium',
};

export default fr;
